<div class="layout-time-container scrollable-component-container">
  <div
    class="attribute-editor-component scrollable-component-settings te-scrollable-container"
  >
    <div class="attribute-editor-row" *requireRole="AI_LAYOUT_ROLE">
      <!-- Layout Selection -->
      <div class="form-group layout-selector">
        <label class="control-label" id="layout-selection-label"
          >Choose Layout</label
        >
        <div
          class="layout-container"
          role="radiogroup"
          aria-labelledby="layout-selection-label"
        >
          <button
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': layout === LayoutType.DIGITAL,
            }"
            (click)="setLayout(LayoutType.DIGITAL)"
            [attr.aria-checked]="layout === LayoutType.DIGITAL"
            role="radio"
          >
            <div class="layout-icon-container layout-inline">12:00</div>
            <div class="layout-label">Digital</div>
          </button>
          <button
            type="button"
            class="layout-option"
            [ngClass]="{
              'layout-option--selected': isCustomLayout,
            }"
            (click)="openLayoutAi()"
            [attr.aria-checked]="isCustomLayout"
            role="radio"
          >
            <div class="layout-icon-container">
              <mat-icon svgIcon="ai-gradient" aria-hidden="true"></mat-icon>
            </div>
            <div class="layout-label">AI layout</div>
          </button>
        </div>
        <layout-ai-edit-button
          id="te-lt-edit-layout"
          [shown]="isCustomLayout"
          (edit)="editLayoutAi()"
        ></layout-ai-edit-button>
      </div>
    </div>

    <div class="attribute-editor-row">
      <!-- Time Format Selection -->
      <div class="form-group">
        <label>Time Format</label>
        <mat-button-toggle-group
          [(ngModel)]="timeFormat"
          (ngModelChange)="setTimeFormat($event)"
          hideSingleSelectionIndicator="true"
        >
          <mat-button-toggle value="Hours12">12h</mat-button-toggle>
          <mat-button-toggle value="Hours24">24h</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>

    <div class="attribute-editor-row">
      <div class="form-group">
        <label id="te-lt-timezone-label">Time Zone</label>
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          class="tw-w-full"
        >
          <mat-select
            id="te-lt-timezone"
            [(ngModel)]="timezone"
            (selectionChange)="save()"
            aria-labelledby="te-lt-timezone-label"
          >
            <mat-option value="">Display's Time Zone (Default)</mat-option>
            @for (tz of WORLD_TIMEZONES; track tz) {
              <mat-option [value]="tz">{{ tz }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="attribute-editor-row" [shown]="usesAttribute('color')">
      <!-- Color Picker -->
      <div class="form-group">
        <label>Color</label>
        <div class="flex-row left-right-aligner">
          <color-picker
            pickerId="te-lt-color"
            [(ngModel)]="color"
            (change)="save()"
            ngDefaultControl
          ></color-picker>
        </div>
      </div>
    </div>
  </div>
</div>
